import { Stack, Typography } from '@mui/material';
import { formatPrice } from '@retail/products/utils';
import { useMemo } from 'react';
import { useProductsTFunction } from '@retail/products/i18n';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

interface Props {
  unit: string;
  price?: number;
  priceDate?: string;
}

export const OurPriceCell: React.FC<Props> = ({ price, unit, priceDate }) => {
  const { i18n } = useTranslation();
  const displayPrice = useMemo(
    () => (price ? formatPrice(price, i18n.language) : '-'),
    [i18n.language, price]
  );
  const t = useProductsTFunction();

  return (
    <Stack alignItems="center">
      <Typography variant="subtitle2" component="span">
        {t('products.prices.pricePerUnit', { price: displayPrice, unit })}
      </Typography>

      <Typography variant="body2">{priceDate ? dayjs(priceDate).format('ll') : ''}</Typography>
    </Stack>
  );
};
